import React from 'react'
import {FaDownload} from 'react-icons/fa'
import {RoleGuard} from '../../permissions/RoleGuard'

interface Props {
  url: string
  allowedRoles: number[]
}

export default function DownloadPdfButton({url, allowedRoles}: Props) {
  return (
    <RoleGuard allowedRoles={allowedRoles}>
      <a
        href={url}
        download
        className='d-flex align-items-center bg-primary text-white p-2 rounded-3 text-decoration-none'
      >
        <FaDownload className='me-1 text-white' />
        <p className='text-white'>Download PDF</p>
      </a>
    </RoleGuard>
  )
}
